import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import { AppModule } from './app/app.module';
import { environment } from "./environments/environment";

Sentry.init({
  dsn: "https://764bb4501ff0dfc875580f21fcf5b6dd@sentry.safemgr.com/2",
  sendDefaultPii: true,
  environment: environment.sentryEnvironment,
  release: environment.sentryRelease
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));